import { render, staticRenderFns } from "./PermPlacementsListing.vue?vue&type=template&id=041fdb87&scoped=true&"
import script from "./PermPlacementsListing.vue?vue&type=script&lang=js&"
export * from "./PermPlacementsListing.vue?vue&type=script&lang=js&"
import style0 from "./PermPlacementsListing.vue?vue&type=style&index=0&id=041fdb87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fdb87",
  null
  
)

export default component.exports